import React from 'react'
import { Prompt } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import { message, notification } from 'antd'
import {
  getSummaryEmail,
  updateScreenshort,
  saveSummaryEmail,
  getEmailDetail,
  getLastComments,
  getSummaryEmailChangeLog,
  getEmailTemplate,
  getStatisticsLog,
  updateEmailAction
} from '../../api/summaryEmail'
import { getLiveProgram } from '../../api/program'
import {
  getOverviewSummary
  // saveOverviewSummary
} from '../../api/microGoals'
import { getClientProfileInfo, getAllExperts } from '../../api/team'
import SucceedMessage from './comp/succeedMessage'
import Undo from './comp/undo'
import { loadUser } from '../../utils/storage'
import { capitalize } from '../../utils/common'
import {
  getThisWeekRange,
  getShowWeeklyDate,
  prevWeekDate,
  nextWeekDate
} from '../../utils/dateHandles'

import {
  DEFAULT_TITLE,
  EMAIL_ACTION,
  SLEEP_GOALS,
  INIT_DATA,
  ACTIVITY_GOALS
} from './constant'

export default (WrappedComponent) =>
  class WeeklySummaryWrapper extends React.Component {
    state = {
      initailSubmit: true,
      startDate: null,
      endDate: null,
      showDate: '',
      hideArrow: '',
      data: null,
      submitData: _.cloneDeep(INIT_DATA),
      originInformation: null,
      loading: false,
      msg: null,
      editingTextNumber: 0,
      confirmMessage: 'Are you sure you want to leave this page?',
      changedSubject: null,
      undo: false
    }

    handleScreenshorts = async (data, submitData) => {
      const { person } = this.props
      const { data: originData } = this.state

      const { nutrition, rejuvenation } = originData

      const formatListToObj = (array) => {
        const result = {}
        for (const { id, url } of array) {
          result[id] = url
        }
        return result
      }

      const result = await updateScreenshort(data, person.id)
      const ChartUrlObj = {}
      const overview = result
        .filter((item) => item.id.includes('overview.'))
        .map((item) => {
          item.id = item.id.replace('overview.', '')
          return item
        })
      ChartUrlObj.overview = formatListToObj(overview)
      submitData.overview = Object.assign(
        submitData.overview,
        ChartUrlObj.overview
      )
      /* handle rejuvenation screenshots --start */
      const sleepGoals = result
        .filter((item) => item.id.includes('rejuvenation.'))
        .map((item) => {
          item.id = item.id.replace('rejuvenation.', '')
          return item
        })
      ChartUrlObj.rejuvenation = formatListToObj(sleepGoals)

      const sleepChart = ChartUrlObj.rejuvenation.sleep_chart_url
      submitData.rejuvenation.sleep_chart_url = sleepChart ? sleepChart : ''
      submitData.rejuvenation.deleted_sleep_goal =
        submitData.rejuvenation.deleted_sleep_goal || []
      submitData.rejuvenation.sleep_goals = SLEEP_GOALS.filter(
        (item) =>
          !submitData.rejuvenation.deleted_sleep_goal.find(
            (id) => id === item.id
          )
      ).concat(
        rejuvenation
          .filter(
            (item) =>
              !submitData.rejuvenation.deleted_sleep_goal.find(
                (id) => id === item.id
              )
          )
          .map(({ id, description }) => ({
            id,
            description
          }))
      )

      for (const goal of submitData.rejuvenation.sleep_goals) {
        goal.chart_url = ChartUrlObj.rejuvenation[`chart_url.${goal.id}`]
      }

      /* handle rejuvenation screenshots --end */

      /* handle exercise screenshots --start */
      const exercise = result
        .filter((item) => item.id.includes('exercise.'))
        .map((item) => {
          item.id = item.id.replace('exercise.', '')
          return item
        })

      ChartUrlObj.exercise = formatListToObj(exercise)
      const { heart_chart_url, workout_chart_url } = ChartUrlObj.exercise // chart_url.1
      submitData.exercise = Object.assign(submitData.exercise, {
        heart_chart_url,
        workout_chart_url
      })

      submitData.exercise.deleted_activity_goal =
        submitData.exercise.deleted_activity_goal || []

      submitData.exercise.activity_goals = ACTIVITY_GOALS.filter(
        (item) =>
          !submitData.exercise.deleted_activity_goal.find(
            (id) => id === item.id
          )
      )
      if (submitData.exercise.activity_goals.length > 0) {
        let urlObj = submitData.exercise.activity_goals.find(
          (item) => item.id === 3
        )
        urlObj.chart_url = ChartUrlObj.exercise['chart_url.3']
      }
      /* handle exercise screenshots --end */

      /* handle weight screenshort -- start */
      ChartUrlObj.weight = result.filter((item) => item.id.includes('weight.'))
      submitData.overview.deleted_weight =
        submitData.overview.deleted_weight || []
      const weightGoals = nutrition
        .filter(
          (item) =>
            !submitData.overview.deleted_weight.find((id) => id === item.id) &&
            item.description.toLowerCase().includes('weight')
        )
        .map(({ id, description }) => ({ id, description }))

      for (const weight of ChartUrlObj.weight) {
        let urlObj = weightGoals.find((item) =>
          weight.id.includes(`${item.id}`)
        )
        if (urlObj) {
          urlObj = urlObj.chart_url = weight.url
        }
      }
      submitData.weight = weightGoals
      /* handle weight screenshort -- end */

      /* handle nutrition screenshort -- start */
      ChartUrlObj.nutrition = result.filter((item) =>
        item.id.includes('nutrition.')
      )

      submitData.deleted_nutritions = submitData.deleted_nutritions || []

      const nutritionGoals = nutrition
        .filter(
          (item) =>
            !item.description.toLowerCase().includes('weight') &&
            !submitData.deleted_nutritions.find((id) => id === item.id)
        )
        .map(({ id, description, unit }) => ({ id, description, unit }))

      for (const nutrition of ChartUrlObj.nutrition) {
        let urlObj = nutritionGoals.find((item) =>
          nutrition.id.includes(`${item.id}`)
        )
        if (urlObj) {
          urlObj = urlObj.chart_url = nutrition.url
        }
      }
      submitData.nutrition = nutritionGoals
      /* handle nutrition screenshort -- end */

      return submitData
    }

    getProgramInfo = () => {
      const { programData, startDate } = this.state
      const {
        exercise: { program }
      } = programData
      if (!program) return null
      const from = moment(program.from),
        to = moment(program.to)

      const totalWeek = to.diff(from, 'week') + 1
      const currentWeek = startDate.diff(from, 'week') + 1

      const title = `  •  ${program.name}  • Week ${currentWeek} of ${totalWeek}`

      return title
    }

    submit = async (action, section, submitData, data, ccList) => {
      const loginUser = loadUser()
      const { person, id, saveSync, createSync } = this.props

      const {
        startDate,
        endDate,
        ouraRingConnected,
        data: { nutrition, sleep },
        initailSubmit,
        originInformation
      } = this.state

      if (initailSubmit) {
        submitData.nutrition = submitData.nutrition.filter((item) =>
          nutrition.find((n) => n.id === item.id)
        )
        this.setState({ initailSubmit: false })
      }

      let email
      if (action === EMAIL_ACTION.sent) {
        email = person.email
      } else if (action === EMAIL_ACTION.send_test_email) {
        email = loginUser.email
      }
      try {
        if (data) {
          // when send email/test email, need to save screenshots first
          submitData = await this.handleScreenshorts(data, submitData)
          if (!ouraRingConnected && !(sleep && sleep.details)) {
            submitData.deleted_section.rejuvenation = true
          }

          submitData.nutrition = submitData.nutrition.filter(
            (item) => item.description && item.chart_url
          )
          if (!submitData.overview.title) {
            submitData.overview.title = DEFAULT_TITLE
          }
        }

        if (ccList) {
          submitData.cc_list = ccList
        }

        if (action === 'sent' || action === 'send_test_email') {
          // calculate sectin show
          if (originInformation.status === 'Draft' || !submitData.date_range) {
            submitData.date_range = `${startDate.format(
              'MMM DD'
            )} - ${endDate.format('MMM DD')}`
            const programInfo = this.getProgramInfo()
            if (programInfo) {
              submitData.date_range += programInfo
            }
          }
          const {
            weight,
            weight_recommendation,
            nutrition,
            nutrition_recommendation,
            rejuvenation,
            deleted_section,
            exercise
          } = submitData

          submitData.section_show = {
            rejuvenation:
              !deleted_section.rejuvenation &&
              (!!rejuvenation.recommendation ||
                !deleted_section.rejuvenation_quality ||
                rejuvenation.sleep_goals.length > 0),
            exercise:
              !deleted_section.exercise &&
              (!deleted_section.exercise_target ||
                !deleted_section.exercise_workout ||
                exercise.activity_goals.length > 0 ||
                !!exercise.recommendation),
            weight:
              !deleted_section.weight &&
              (weight.length > 0 || !!weight_recommendation),
            nutrition:
              !deleted_section.nutrition &&
              (nutrition.length > 0 || !!nutrition_recommendation)
          }
        }

        const params = {
          personId: person.id,
          from: startDate.format('YYYY-MM-DD'),
          to: endDate.format('YYYY-MM-DD'),
          email_id: id === 'new' ? null : Number(id),
          action,
          section
        }
        const result = await saveSummaryEmail(params, submitData)

        delete submitData.log_deleted_content
        delete submitData.log_deleted_position

        if (result.id && id === 'new') {
          createSync(result.id)
        }
        if (
          action === EMAIL_ACTION.sent ||
          action === EMAIL_ACTION.send_test_email
        ) {
          const msg = message.open({
            content: (
              <SucceedMessage
                status={action === 'draft' ? 'saved' : 'sent'}
                email={email}
                onDismiss={() => this.state.msg && setTimeout(msg)}
              />
            ),
            duration: 5
          })

          this.setState({ msg })

          action === EMAIL_ACTION.sent && saveSync()
        }
      } catch (err) {
        console.error(err)
        this.setState({ submitError: err, showAPIError: true })
        notification.error({
          message: 'Failed to send',
          description: err.message,
          duration: 15
        })
        throw err
      }

      // update logs
      this.fetchChangeLog()
    }

    handleUndo = async (position, section, content) => {
      if (position) {
        const { submitData } = this.state
        submitData.log_deleted_position = position
        submitData.log_deleted_content = content
        const targets = position.split('.')
        const finalPosition = targets.pop()
        let target = submitData
        for (const key of targets) {
          target = target[key]
        }

        if (position.includes('deleted_section.')) {
          target[finalPosition] = false
          const exercisePart = [
            'exercise_workout',
            'exercise_target',
            'exercise_training_target',
            'exercise_target_breakdown'
          ]
          if (exercisePart.find((part) => position.includes(part))) {
            submitData.deleted_section.exercise = false
            if (
              ['exercise_training_target', 'exercise_target_breakdown'].find(
                (part) => position.includes(part)
              )
            ) {
              submitData.deleted_section.exercise_target = false
            }
          } else if (position.includes('rejuvenation_quality')) {
            submitData.deleted_section.rejuvenation = false
          }
        } else if (content) {
          content = JSON.parse(content)
          if (content.element) {
            target[finalPosition] = target[finalPosition].filter(
              (item) => item !== content.element
            )
          } else if (content.text) {
            target[finalPosition] = content.text
          }
        }

        await this.submit(EMAIL_ACTION.undo, section, submitData)
        this.setState({ submitData, undo: null })
      } else {
        const { originInformation, undo } = this.state
        await this.submit(EMAIL_ACTION.undo, undo, originInformation.body)
        this.setState({ submitData: originInformation.body, undo: null })
      }
    }

    getDoneStatus = (status) => {
      const loginUser = loadUser()
      return status === 'done'
        ? `Marked as done by ${(loginUser.profile &&
            loginUser.profile.nickname) ||
            loginUser.first_name} at ${moment().format(
            'MMM D, YYYY hh:mm:ss A'
          )}`
        : ''
    }

    removeTextPart = async (params) => {
      const { part, field, section } = params
      const { person, id, createSync } = this.props
      const { submitData, originInformation, startDate, endDate } = this.state
      originInformation.body = _.cloneDeep(submitData)
      if (part) {
        submitData.log_deleted_position = `${part}.${field}`
        submitData.log_deleted_content = JSON.stringify({
          text: submitData[part][field]
        })
        submitData[part][`${field}_is_hide`] = true
      } else {
        submitData.log_deleted_position = `${field}`
        submitData.log_deleted_content = JSON.stringify({
          text: submitData[field]
        })
        submitData[`${field}_is_hide`] = true
      }

      this.setState({
        submitData,
        originInformation,
        undo: section
      })

      try {
        const result = await saveSummaryEmail(
          {
            personId: person.id,
            from: startDate.format('YYYY-MM-DD'),
            to: endDate.format('YYYY-MM-DD'),
            email_id: id === 'new' ? null : Number(id),
            action: EMAIL_ACTION.delete,
            section
          },
          submitData
        )

        if (result.id && id === 'new') {
          createSync(result.id)
        }

        delete submitData.log_deleted_content
        delete submitData.log_deleted_position
      } catch (err) {
        console.error(err)
      }

      // update logs
      this.fetchChangeLog()

      // // auto save
      // this.submit(
      //   EMAIL_ACTION.delete,
      //   section,
      //   submitData
      // )
    }

    setSubmitData = async (params) => {
      const { part, field, value, status, id, section } = params
      const { submitData, originInformation } = this.state
      const doneStatus = this.getDoneStatus(status)
      if (status === 'delete') {
        originInformation.body = _.cloneDeep(submitData)
        // undo information
        if (part) {
          submitData.log_deleted_position = `${part}.${field}`
          submitData.log_deleted_content = JSON.stringify({
            text: submitData[part][field]
          })
        } else {
          submitData.log_deleted_position = `${field}`
          submitData.log_deleted_content = JSON.stringify({
            text: submitData[field]
          })
        }
      }
      if (part === 'nutrition') {
        let index = submitData.nutrition.findIndex((item) => item.id === id)
        if (index !== -1) {
          submitData.nutrition[index][field] = value
          submitData.nutrition[index][`${field}_status`] = doneStatus
        } else {
          submitData.nutrition.push({
            id,
            [field]: value,
            [`${field}_status`]: doneStatus
          })
        }
      } else if (part) {
        submitData[part][field] = value
        submitData[part][`${field}_status`] = doneStatus
        if (submitData[part][`${field}_is_hide`]) {
          delete submitData[part][`${field}_is_hide`]
        }
      } else {
        submitData[field] = value
        if (field !== 'email_subject') {
          submitData[`${field}_status`] = doneStatus
        }
        if (submitData[`${field}_is_hide`]) {
          delete submitData[`${field}_is_hide`]
        }
      }

      this.setState({
        submitData,
        originInformation,
        undo: status === 'delete' ? section : null
      })
      // auto save
      this.submit(
        status === 'delete'
          ? EMAIL_ACTION.delete
          : status === 'done'
          ? EMAIL_ACTION.mark_as_done
          : EMAIL_ACTION.save_as_draft,
        section,
        submitData
      )
    }

    deleteSections = async (section) => {
      const { submitData, originInformation } = this.state
      originInformation.body = _.cloneDeep(submitData)
      submitData.deleted_section[section] = true
      submitData.log_deleted_position = `deleted_section.${section}`

      if (section === 'exercise_workout' || section === 'exercise_target') {
        if (
          submitData.deleted_section.exercise_workout &&
          submitData.deleted_section.exercise_target &&
          submitData.exercise.deleted_activity_goal &&
          submitData.exercise.deleted_activity_goal.length === 2
        ) {
          submitData.deleted_section.exercise = true
        }
      }
      if (
        section === 'exercise_training_target' ||
        section === 'exercise_target_breakdown'
      ) {
        if (
          submitData.deleted_section.exercise_training_target &&
          submitData.deleted_section.exercise_target_breakdown
        ) {
          submitData.deleted_section.exercise_target = true
        }
      }
      if (section === 'rejuvenation_quality') {
        if (
          submitData.deleted_section.rejuvenation_quality &&
          submitData.rejuvenation.deleted_sleep_goal &&
          submitData.rejuvenation.deleted_sleep_goal.length === 2
        ) {
          submitData.deleted_section.rejuvenation = true
        }
      }
      section = capitalize(section.split('_').join(' '))

      await this.submit(EMAIL_ACTION.delete, section, submitData)

      this.setState({ submitData, undo: section, originInformation })
    }

    deleteOverviewPart = (section, id, description) => {
      const { submitData, data, originInformation } = this.state
      originInformation.body = _.cloneDeep(submitData)
      if (section === 'overview.deleted_rejuvenation') {
        submitData.overview.deleted_rejuvenation.push(id)
        if (submitData.overview.deleted_rejuvenation.length === 3) {
          submitData.overview.rejuvenation_recommendation = ''
        }
      } else if (section === 'overview.deleted_exercise') {
        submitData.overview.deleted_exercise.push(id)
        if (submitData.overview.deleted_exercise.length === 3) {
          submitData.overview.exercise_recommendation = ''
        }
      } else if (section === 'overview.deleted_nutritions') {
        submitData.overview.deleted_nutritions.push(id)
        if (
          submitData.overview.deleted_nutritions.length ===
          data.nutrition.filter(
            (item) => !item.description.toLowerCase().includes('weight')
          ).length
        ) {
          submitData.overview.nutrition_recommendation = ''
        }
      } else if (section === 'overview.deleted_weight') {
        submitData.overview.deleted_weight.push(id)
        if (
          submitData.overview.deleted_weight.length ===
          data.nutrition.filter((item) =>
            item.description.toLowerCase().includes('weight')
          ).length
        ) {
          submitData.overview.weight_recommendation = ''
        }
      }
      section = `${section
        .split('.deleted_')
        .map((item) => capitalize(item))
        .join(' - ')} : ${description}`
      this.submit(EMAIL_ACTION.delete, section, submitData)
      this.setState({ submitData, originInformation, undo: section })
    }

    oprExercise = (type, obj) => {
      const { submitData, originInformation } = this.state
      if (type === 'delete') {
        originInformation.body = _.cloneDeep(submitData)
        if (!submitData.exercise.deleted_activity_goal) {
          submitData.exercise.deleted_activity_goal = []
        }
        submitData.exercise.deleted_activity_goal.push(obj.id)
        // undo information
        submitData.log_deleted_position = 'exercise.deleted_activity_goal'
        submitData.log_deleted_content = JSON.stringify({ element: obj.id }) // array element
        if (
          submitData.deleted_section.exercise_workout &&
          submitData.deleted_section.exercise_target &&
          submitData.exercise.deleted_activity_goal.length === 2
        ) {
          submitData.deleted_section.exercise = true
        }
        this.submit(EMAIL_ACTION.delete, obj.section, submitData)
      } else {
        const { id, field, value, status, section } = obj
        const doneStatus = this.getDoneStatus(status)
        if (!submitData.exercise.activity_goals) {
          submitData.exercise.activity_goals = []
        }
        let index = submitData.exercise.activity_goals.findIndex(
          (item) => item.id === id
        )
        if (index !== -1) {
          submitData.exercise.activity_goals[index][field] = value
          submitData.exercise.activity_goals[index][
            `${field}_status`
          ] = doneStatus
        } else {
          submitData.exercise.activity_goals.push({
            id,
            [field]: value,
            [`${field}_status`]: doneStatus
          })
        }

        // auto save
        this.submit(
          status === 'done'
            ? EMAIL_ACTION.mark_as_done
            : EMAIL_ACTION.save_as_draft,
          section,
          submitData
        )
      }
      this.setState({
        submitData,
        originInformation,
        undo: type === 'delete' ? obj.section : null
      })
    }

    oprRejuvenation = (type, obj) => {
      const { submitData, originInformation } = this.state
      if (type === 'delete') {
        originInformation.body = _.cloneDeep(submitData)
        if (!submitData.rejuvenation.deleted_sleep_goal) {
          submitData.rejuvenation.deleted_sleep_goal = []
        }
        submitData.rejuvenation.deleted_sleep_goal.push(obj.id)
        if (
          submitData.deleted_section.rejuvenation_quality &&
          submitData.rejuvenation.deleted_sleep_goal &&
          submitData.rejuvenation.deleted_sleep_goal.length === 2
        ) {
          submitData.deleted_section.rejuvenation = true
        }
        // undo information
        submitData.log_deleted_position = 'rejuvenation.deleted_sleep_goal'
        submitData.log_deleted_content = JSON.stringify({ element: obj.id })
        this.submit(EMAIL_ACTION.delete, obj.section, submitData)
      } else {
        const { id, field, value, status, section } = obj
        const doneStatus = this.getDoneStatus(status)
        if (!submitData.rejuvenation.sleep_goals) {
          submitData.rejuvenation.sleep_goals = []
        }
        let index = submitData.rejuvenation.sleep_goals.findIndex(
          (item) => item.id === id
        )
        if (index !== -1) {
          submitData.rejuvenation.sleep_goals[index][field] = value
          submitData.rejuvenation.sleep_goals[index][
            `${field}_status`
          ] = doneStatus
        } else {
          submitData.rejuvenation.sleep_goals.push({
            id,
            [field]: value,
            [`${field}_status`]: doneStatus
          })
        }
        // auto save

        this.submit(
          status === 'done'
            ? EMAIL_ACTION.mark_as_done
            : EMAIL_ACTION.save_as_draft,
          section,
          submitData
        )
      }
      this.setState({
        submitData,
        originInformation,
        undo: type === 'delete' ? obj.section : null
      })
    }

    deleteNutrition = (section, id, description) => {
      const { submitData, originInformation } = this.state
      originInformation.body = _.cloneDeep(submitData)
      submitData.deleted_nutritions.push(id)
      section = `${capitalize(section)} : ${description}`
      // undo information
      submitData.log_deleted_position = 'deleted_nutritions'
      submitData.log_deleted_content = JSON.stringify({ element: id })
      this.submit(EMAIL_ACTION.delete, section, submitData)
      this.setState({ submitData, originInformation, undo: section })
    }

    deleteWeight = (section, id, description) => {
      const { submitData, originInformation } = this.state
      originInformation.body = _.cloneDeep(submitData)
      submitData.overview.deleted_weight.push(id)
      section = `${capitalize(section)} : ${description}`
      // undo information
      submitData.log_deleted_position = 'overview.deleted_weight'
      submitData.log_deleted_content = JSON.stringify({ element: id })
      this.submit(EMAIL_ACTION.delete, section, submitData)
      this.setState({ submitData, originInformation, undo: section })
    }

    clearAllChanges = () => {
      const { originInformation } = this.state
      this.setState({
        submitData: _.cloneDeep(originInformation.body)
      })
    }

    prevDate = () => {
      const { submitData } = this.state
      let { startDate, endDate } = prevWeekDate(
        this.state.startDate,
        this.state.endDate
      )
      this.getShowDate(startDate, endDate)
      this.setState({
        startDate,
        endDate
      })
      this.fetchSummaryEmailData(startDate, endDate)
      if (!Number(this.props.id)) this.getCommendData(startDate, endDate)
      // auto save
      // submitData.email_subject = `Weekly summary email (${startDate &&
      //   startDate.format('MMM D')} - ${endDate && endDate.format('MMM D')})`
      this.submit(EMAIL_ACTION.save_as_draft, null, submitData)
    }

    nextDate = () => {
      const { submitData } = this.state
      let { startDate, endDate } = nextWeekDate(
        this.state.startDate,
        this.state.endDate
      )
      this.getShowDate(startDate, endDate)
      this.setState({
        startDate,
        endDate
      })
      this.fetchSummaryEmailData(startDate, endDate)
      if (!Number(this.props.id)) this.getCommendData(startDate, endDate)
      // auto save
      // submitData.email_subject = `Weekly summary email (${startDate &&
      //   startDate.format('MMM D')} - ${endDate && endDate.format('MMM D')})`
      this.submit(EMAIL_ACTION.save_as_draft, null, submitData)
    }

    getShowDate(startDate, endDate) {
      const { originInformation } = this.state
      let showDate = getShowWeeklyDate(startDate, endDate)
      let hideArrow = ''
      if (showDate === 'This week') {
        hideArrow = 'right'
      }
      if (
        originInformation &&
        (originInformation.status === 'Sent' ||
          originInformation.status === 'Opened')
      ) {
        hideArrow = 'left, right'
      }
      this.setState({
        showDate,
        hideArrow
      })
    }

    getCommendData = async (startDate, endDate) => {
      const { id, person, createSync } = this.props
      let originInformation

      if (Number(id)) {
        const detail = await getEmailDetail(person.id, id)
        detail.body.overview.deleted_rejuvenation =
          detail.body.overview.deleted_rejuvenation || []
        detail.body.overview.deleted_exercise =
          detail.body.overview.deleted_exercise || []
        detail.body.overview.deleted_weight =
          detail.body.overview.deleted_weight || []
        originInformation = detail
        detail.body.deleted_section = detail.body.deleted_section || {}
      } else {
        const detail = await getLastComments(
          person.id,
          startDate.format('YYYY-MM-DD'),
          endDate.format('YYYY-MM-DD')
        )
        const params = {
          personId: person.id,
          from: startDate.format('YYYY-MM-DD'),
          to: endDate.format('YYYY-MM-DD'),
          email_id: id === 'new' ? null : Number(id),
          action: EMAIL_ACTION.create,
          section: null
        }
        originInformation = {
          body: _.cloneDeep(INIT_DATA),
          person_id: person.id
        }
        if (detail.comments) {
          originInformation.body = this.state.submitData
          const copyComments = {}
          for (let item of [
            'rejuvenation',
            'exercise',
            'nutrition',
            'overview'
          ]) {
            const targetObj = detail.comments[item]
            if (Array.isArray(targetObj)) {
              copyComments[item] = targetObj.map(
                ({ custom_text, id, unit }) => ({
                  custom_text,
                  id,
                  unit
                })
              )
            } else {
              const copyObj = {}
              for (let i of Object.keys(targetObj)) {
                if (
                  i.match(
                    /recommendation$|summary_introduction$|custom_text$|areas_of_focus$|long_term_aspirations$/g
                  )
                )
                  copyObj[i] = targetObj[i]
              }
              copyComments[item] = copyObj
            }
          }
          Object.keys(originInformation.body).forEach((item) => {
            if (copyComments[item])
              Object.assign(originInformation.body[item], copyComments[item])
          })

          if (detail.comments.nutrition_recommendation) {
            originInformation.body.nutrition_recommendation =
              detail.comments.nutrition_recommendation
          }
          if (detail.comments.weight_recommendation) {
            originInformation.body.weight_recommendation =
              detail.comments.weight_recommendation
          }
        } else {
          // call peofile to get AOF and LTA
          originInformation.body.overview.areas_of_focus =
            person.profile.areas_of_focus
          originInformation.body.overview.long_term_aspirations =
            person.profile.long_term_aspirations
        }

        // create email first
        const result = await saveSummaryEmail(params, originInformation.body)
        if (result.id && id === 'new') {
          createSync(result.id)
        }
      }

      const submitData = _.cloneDeep(originInformation.body)
      const state = { submitData }
      if (!this.state.originInformation) {
        state.originInformation = originInformation
      }
      this.setState(state)
      return originInformation
    }

    fetchSummaryEmailData = async (startDate, endDate) => {
      const { person } = this.props
      this.setState({ loading: true })
      try {
        const from = startDate.format('YYYY-MM-DD')
        const to = endDate.format('YYYY-MM-DD')
        const data = await getSummaryEmail(from, to, person.id)

        const overview = await getOverviewSummary(from, to, person.id)

        const programData = await getLiveProgram(person.id, from, to)

        data.overview = overview

        data.nutrition.map((item) => {
          item.formatChange =
            item.change_type === 'percentage'
              ? Math.round(item.change * 100)
              : item.change
          item.changeUnit = item.change_type === 'percentage' ? '%' : ''

          return item
        })

        this.setState({
          data,
          programData,
          loading: false
        })
      } catch (err) {
        this.setState({ loading: false })
      }
    }

    fetchChangeLog = async () => {
      const { id } = this.props
      try {
        let data = []
        if (Number(id)) {
          data = await getSummaryEmailChangeLog(id)
        }
        this.setState({
          changeLog: data.reverse()
        })
      } catch (err) {
        console.error(err)
      }
    }

    fetchStatisticsLog = async () => {
      const { person } = this.props
      try {
        const data = await getStatisticsLog(person.id)
        this.setState({
          statisticsLog: data
        })
      } catch (err) {
        console.error(err)
      }
    }

    beforeunload = (env) => {
      const {
        editingTextNumber,
        changedSubject,
        submitData,
        confirmMessage
      } = this.state
      if (
        editingTextNumber > 0 ||
        (changedSubject && changedSubject !== submitData.email_subject)
      ) {
        let count = editingTextNumber
        while (count > 0) {
          this.updateEmailAction(1)
          count--
        }
        if (env) {
          env.preventDefault()
          env.returnValue = confirmMessage
        }
        return confirmMessage
      }
    }

    updateEmailAction = (action) => updateEmailAction(this.props.id, action)

    initial = async () => {
      const { person, loginRole, setEditingTextNumber } = this.props
      let { startDate, endDate } = getThisWeekRange()
      // disable this week, default last week
      // startDate = startDate.day(-6)
      // endDate = endDate.day(-7)

      const originInformation = await this.getCommendData(startDate, endDate)

      if (originInformation.person_id !== person.id) {
        console.log('This email nit belongs to current client.')
        this.setState({ emailNotFound: true })
        return
      }

      if (originInformation.from) {
        startDate = moment(originInformation.from)
        endDate = moment(originInformation.to)
      }

      this.getShowDate(startDate, endDate)
      this.fetchSummaryEmailData(startDate, endDate)
      let templates = []

      if (loginRole !== 'User') {
        this.fetchChangeLog()
        this.fetchStatisticsLog()
        templates = await getEmailTemplate()
      }

      const { device_info } = await getClientProfileInfo(person.id)
      if (setEditingTextNumber) {
        setEditingTextNumber(0) // initial editing number of redux
      }
      //get all expert
      const { clients } = await getAllExperts()
      this.setState({
        startDate,
        endDate,
        templates,
        experts: clients,
        ouraRingConnected:
          device_info && device_info.ouraring.connection_status === 'Connected'
      })
    }

    syncData = async () => {
      const { startDate, endDate } = this.state
      const originInformation = await this.getCommendData(startDate, endDate)
      await this.fetchChangeLog()
      this.setState({ originInformation })
    }

    lostConnect = () => {
      const { submitData } = this.state
      this.setState({
        editingTextNumber: 0,
        changedSubject: submitData && submitData.email_subject
      })
    }

    componentDidMount() {
      this.setState({ loading: true })
      this.initial()
    }

    render() {
      const { changedSubject, submitData, undo, confirmMessage } = this.state
      const childProps = {
        ...this.state,
        lostConnect: this.lostConnect,
        syncData: this.syncData,
        prevDate: this.prevDate,
        nextDate: this.nextDate,
        clearAllChanges: this.clearAllChanges,
        setSubmitData: this.setSubmitData,
        removeTextPart: this.removeTextPart,
        deleteNutrition: this.deleteNutrition,
        deleteWeight: this.deleteWeight,
        // deleteOverviewPart: this.deleteOverviewPart,
        deleteSections: this.deleteSections,
        oprRejuvenation: this.oprRejuvenation,
        oprExercise: this.oprExercise,
        submit: this.submit,
        updateEmailAction: this.updateEmailAction,
        EmailAction: EMAIL_ACTION,
        handleUndo: this.handleUndo,
        updateEditingCount: (count) => {
          const editingTextNumber = this.state.editingTextNumber + count
          if (this.props.setEditingTextNumber) {
            this.props.setEditingTextNumber(editingTextNumber)
          }
          this.setState({ editingTextNumber })
        },
        beforeunload: this.beforeunload,
        unload: this.unload,
        changeSubject: (subject) => this.setState({ changedSubject: subject })
      }

      return (
        <>
          <Prompt
            when={
              this.state.editingTextNumber > 0 ||
              (changedSubject && changedSubject !== submitData.email_subject)
            }
            message={(location) => {
              if (
                window.location.pathname.includes('news') &&
                location.pathname.includes('/detail/summary-email/')
              ) {
                return false
              } else {
                return confirmMessage
              }
            }}
          />
          <WrappedComponent {...childProps} {...this.props} />
          {undo && (
            <Undo
              duration={10}
              position={undo}
              close={() => this.setState({ undo: null })}
              undo={this.handleUndo}
            />
          )}
        </>
      )
    }
  }
